// Digital Image Resolution units with conversion factors to dot/meter
export const digitalImageResolutionUnits = [
  { id: 'dot-per-meter', name: 'Dot/Meter', symbol: 'dpm', plural: 'Dots/Meter', factor: 1 },
  { id: 'dot-per-millimeter', name: 'Dot/Millimeter', symbol: 'dpmm', plural: 'Dots/Millimeter', factor: 1000 },
  { id: 'dot-per-inch', name: 'Dot/Inch (DPI)', symbol: 'dpi', plural: 'Dots/Inch', factor: 39.3700787402 },
  { id: 'pixel-per-inch', name: 'Pixel/Inch (PPI)', symbol: 'ppi', plural: 'Pixels/Inch', factor: 39.3700787402 },
  { id: 'pixel-per-meter', name: 'Pixel/Meter', symbol: 'ppm', plural: 'Pixels/Meter', factor: 1 },
  { id: 'pixel-per-centimeter', name: 'Pixel/Centimeter', symbol: 'ppcm', plural: 'Pixels/Centimeter', factor: 100 },
];

export const popularDigitalImageResolutionConversions = [
  { from: 'dot-per-inch', to: 'dot-per-meter' },
  { from: 'dot-per-meter', to: 'dot-per-inch' },
  { from: 'pixel-per-inch', to: 'pixel-per-centimeter' },
  { from: 'pixel-per-centimeter', to: 'pixel-per-inch' },
  { from: 'dot-per-inch', to: 'dot-per-millimeter' },
  { from: 'pixel-per-inch', to: 'pixel-per-meter' },
];

export const getUnitById = (id) => digitalImageResolutionUnits.find(unit => unit.id === id);

export const convertDigitalImageResolution = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert digital image resolution units and learn the conversion formula.`;
};
